export default __webpack_public_path__ + "static/media/submit-button-auto-submit.5a9edbf3.png";